export default __webpack_public_path__ + "static/media/AnimalsGreen_06.ddf9970e.png";